import { connect } from '@cerebral/react'
import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { state } from 'cerebral'
import { DateTime } from 'luxon'
import React from 'react'
import format from '../../../shared/format'
import MetricCard from '../blocks/metric-cards/MetricCard'
import utils from '../../../shared/utils'

const { toDateTime } = utils

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    height: 64,
    [theme.breakpoints.up('md')]: { display: 'flex' },
  },
}))

const TrialNotice = connect(
  {
    freeTrialEndDate: state`account.organization.freeTrialEndDate`,
  },
  ({ freeTrialEndDate }) => {
    const classes = useStyles()

    if (!freeTrialEndDate) {
      return null
    }

    const end = toDateTime(freeTrialEndDate)
    const daysLeft = Math.ceil(end.diff(DateTime.now(), 'days').days)
    if (daysLeft <= 0) {
      return null
    }

    return (
      <Box className={classes.root}>
        <MetricCard
          label="Free Trial Remaining"
          value={format.plural(daysLeft, 'day', { showCount: true })}
          status={daysLeft <= 3 ? 'danger' : 'primary'}
          detail={`Your free trial ends on ${end.toLocaleString(DateTime.DATE_FULL)}.`}
        />
      </Box>
    )
  }
)

export default TrialNotice
